module.exports = __webpack_public_path__ + "img/momo_button_redeem_record_active.b45a6568.png";